var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { createSubcomponent, getCanvasTheme, styled, } from '@workday/canvas-kit-react/common';
import { Popup } from '@workday/canvas-kit-react/popup';
import { space } from '@workday/canvas-kit-react/tokens';
import { useModalHeading, useModalModel } from './hooks';
var ResponsiveModalHeading = styled(Popup.Heading)(function (_a) {
    var _b;
    var theme = _a.theme;
    var canvasTheme = getCanvasTheme(theme);
    return _b = {},
        _b[canvasTheme.breakpoints.down('s')] = {
            marginBottom: space.zero,
        },
        _b;
});
export var ModalHeading = createSubcomponent('h2')({
    displayName: 'Modal.Heading',
    modelHook: useModalModel,
    elemPropsHook: useModalHeading,
})(function (elemProps, Element) {
    return React.createElement(ResponsiveModalHeading, __assign({ as: Element }, elemProps));
});
